import type { Environment } from '../app/models/environment.model';

/**
 * UAT environment - https://connectemp-uat.abm.com
 */
export const environment: Environment = {
  production: false,
  environmentName: 'qa',
  msal: {
    clientId: '5c68d641-4548-497c-b5dd-6c6656247d3c',
    tenantId: '8e4a72ef-928b-45b6-a137-7ed7bb318678',
    authority: `https://login.microsoftonline.com/8e4a72ef-928b-45b6-a137-7ed7bb318678`,
    redirectUri: 'https://workassist.qa.abm.com',
    postLogoutRedirectUri: 'https://workassist.qa.abm.com',
    scopes: [
      'openid',
      'profile',
      'api://90715699-1310-4ae2-822d-fab116c724f6/.default',
    ],
  },
  apiConfig: {
    scopes: [
      'api://90715699-1310-4ae2-822d-fab116c724f6/.default',
    ],
    serverBaseUrl: 'https://api.workassist.qa.abm.com/core',
    ocpApimSubscriptionKey: '2e90382d6cf04df28d8f4d22028526c3',
  },
};
